import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";
import { graphql } from 'gatsby';
import parse from 'html-react-parser';

import { Layout } from '../layouts/Main';

import {
    Header,
    Footer,
    BlockPostSellbox,
    BreadCrumbBlock,
    HelpfulArticleForm,
    Tabs,
} from '../components';


const BlogpostTemplate = (props) => {
    // console.log(props);
    const blogpost = props.data.mb.blogpost.localizations.find(item => item.locale === props.pageContext.locale) || props.data.mb.blogpost;
    const country_code = props.country_code ? props.country_code : "us";

    const saveToLocalStorage = () => {
        const MAX_RV_LENGTH = 5;
        let rv_items = localStorage.getItem('rv_items') ? JSON.parse(localStorage.getItem('rv_items')) : [];
        rv_items = rv_items.filter((item, index) => index < MAX_RV_LENGTH);

        if (rv_items.find(({ id }) => id === blogpost.id)) {
            return; // item already exists
        }

        if (rv_items.length === 5) {
            rv_items.shift(); // remove first item to make room for next item at the end
        }

        rv_items.push({
            id: blogpost.id,
            title: blogpost.title,
            slug: blogpost.slug,
        });

        localStorage.setItem('rv_items', JSON.stringify(rv_items));
    }

    useEffect(() => {
        if (typeof localStorage !== 'undefined') {
            saveToLocalStorage();
        }
    }, []);

    return (
        <Layout>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1, minimum-scale=1" />
                <meta content="article" property="og:type" />
                <meta content={`https://www.freeconferencecall.com${props.uri}`} property="og:url" />
                <meta content={blogpost.preview && blogpost.preview.url ? `https://www.freeconferencecall.com/support-center/api${blogpost.preview.url}` : "https://www.freeconferencecall.com/images/fcc_logo_fb.png"} property="og:image" />
                <link rel="canonical" href={`https://www.freeconferencecall.com${props.uri.replace(`${country_code}/`, '')}`} />
                <meta content={blogpost.title} property="og:title" />
                <meta content="FreeConferenceCall.com" property="og:site_name" />
                <meta content="freeconferencecall" property="fb:admins" />
                {
                    blogpost.metadata.map(item => (
                        <meta key={item.id} name={item.name} content={item.content} />
                    ))
                }

                {(blogpost.status === 'draft') ? <meta content="noindex, nofollow" name="robots" /> : false}

                <title>{blogpost.title} | FreeConferenceCall.com</title>

            </Helmet>
            <Header intl={props.pageContext.intl} categories={props.data.mb.categories} country_code={country_code} />

            <BlockPostSellbox title={blogpost.title} description={blogpost.sub_title} icon={blogpost.title_icon?.url} title_centered={blogpost.title_centered} />

            <BreadCrumbBlock location={props.location} label={blogpost.title} categories={blogpost.categories} subcategories={blogpost.subcategories} country_code={country_code}/>

            <div className="container">
                <div className="row block-sm">
                    <div className="col-md-12">
                        {parse(blogpost.content)}

                        {
                            blogpost?.tab.length > 0 && <Tabs tabs={blogpost.tab} />
                        }
                    </div>
                </div>
            </div>

            <HelpfulArticleForm blogpost_id={blogpost.id} locale={props.pageContext.locale} />
            <Footer />
        </Layout>
    );
};

export default BlogpostTemplate;

export const pageQuery = graphql`
query BlogpostTemplateQuery($id:ID!, $locale:String!) {
    mb {
        blogpost: blogpost(id:$id){
            id
            locale
            title
            title_centered
            sub_title
            preview {
                url
            }
            categories{
                id
                Name
                link
                external_link
                tag
            }
            subcategories{
                id
                name
                link
            }
            content
            title_icon {
                url
            }
            slug
            metadata {
                id
                name
                content
            }
            tab {
                name
                content
            }
            status
            localizations(where: {locale: $locale}) {
                id
                locale
                title
                title_centered
                sub_title
                preview {
                    url
                }
                categories{
                    id
                    Name
                    link
                    external_link
                    tag
                }
                subcategories{
                    id
                    name
                    link
                }
                content
                title_icon {
                    url
                }
                slug
                metadata {
                    id
                    name
                    content
                }
                tab {
                    name
                    content
                }
                status
            }
        }
        categories: categories(where: {in_browse_resources: true}, sort:"index:asc"){
            id
            Name
            link
            external_link
            tag
            index
            locale
            icon {
                url
            }
            localizations(where: {locale: $locale}) {
                id
                Name
                link
                external_link
                tag
                index
                locale
                icon {
                    url
                }
            }
            subcategories {
                id
                description
                name
                link
                tag
                index
                locale
                localizations(where: {locale: $locale}) {
                    id
                    description
                    name
                    link
                    tag
                    index
                    locale
                }
            }
        }
    }
}
`;
